module.exports = require('react-transition-group')
